// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","561":"fb21a5a4","738":"544e0edf","747":"87b26613","748":"cce4b24d","829":"fbfda22b","931":"a85c004e"}[chunkId] + ".chunk.js";
};